import React, { type FC } from 'react'
import { Empty, Typography } from 'antd'
import { WppEmptyIcon } from '../../packages/wpplayout'

const { Title } = Typography

interface IEmptyTablePlaceholderProps {
  title: string
  message: string
  loading?: boolean
}

export const EmptyTablePlaceholder: FC<IEmptyTablePlaceholderProps> = ({
  title,
  message,
  loading = false
}) => {
  return (
    <Empty
      image={loading ? <div style={{ height: 120 }} /> : <WppEmptyIcon />}
      classNames={{ ...(loading) ? { description: 'empty__description--hidden' } : {} }}
      description={(
        <>
          <Title level={3}>{title}</Title>
          {message}
        </>
      )}>
    </Empty>
  )
}
